export function equals(o1: any, o2: any): boolean {
  if (o1 === o2) return true;
  if (o1 === null || o2 === null) return false;
  if (o1 !== o1 && o2 !== o2) return true;

  const t1 = typeof o1;
  const t2 = typeof o2;

  if (t1 === t2 && t1 === 'object') {
    if (Array.isArray(o1)) {
      if (!Array.isArray(o2)) return false;
      if (o1.length === o2.length) {
        for (let i = 0; i < o1.length; i++) {
          if (!equals(o1[i], o2[i])) return false;
        }
        return true;
      }
    } else {
      if (Array.isArray(o2)) return false;

      const keySet: { [key: string]: boolean } = Object.create(null);
      for (const key in o1) {
        if (!equals(o1[key], o2[key])) return false;
        keySet[key] = true;
      }
      for (const key in o2) {
        if (!(key in keySet) && typeof o2[key] !== 'undefined') return false;
      }
      return true;
    }
  }
  return false;
}

export function isDefined(value: any): boolean {
  return typeof value !== 'undefined' && value !== null;
}

export function isObject(item: any): boolean {
  return item && typeof item === 'object' && !Array.isArray(item);
}

export function mergeDeep(target: any, source: any): any {
  const output = Object.assign({}, target);
  if (isObject(target) && isObject(source)) {
    Object.keys(source).forEach((key: string) => {
      if (isObject(source[key])) {
        if (!(key in target)) {
          Object.assign(output, { [key]: source[key] });
        } else {
          output[key] = mergeDeep(target[key], source[key]);
        }
      } else {
        Object.assign(output, { [key]: source[key] });
      }
    });
  }
  return output;
}
